import * as React from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import clx from 'classnames'
import { FaIcon } from '@/lib/fa'
import {
  faArrowAltCircleRight,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons'
import styles from './ImportsHomeCard.module.scss'

type Props = {
  name?: string
  className?: string
  description: string
  icon?: any
  faIcon?: IconDefinition
  href?: string
  title: string
  handleClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const ImportsHomeCard = ({
  name,
  className,
  description,
  icon,
  faIcon,
  title,
  handleClick,
}: Props) => {
  //"tw-flex tw-flex-col tw-justify-between tw-p-5 tw-bg-white"
  return (
    <button
      className={clx(
        styles.importHomeCard,
        {
          [styles.clickable]: !!handleClick,
        },
        className,
      )}
      onClick={handleClick}
      name={name}
    >
      <div className={styles.content}>
        {faIcon ? (
          <div className='tw-mb-2  tw-h-[40px] tw-w-[40px] tw-rounded-lg tw-bg-[#F0F3FF] tw-flex tw-items-center tw-justify-center'>
            <FaIcon icon={faIcon} className={clx('tw-w-7 tw-h-7', styles.icon)} style={{ fill: "url(#fa-gradient)" }} />
          </div>
        ) : icon ? (
          <div
            className={
              'tw-grid tw-h-[40px] tw-w-[40px] tw-mb-2 tw-place-items-center tw-rounded-lg tw-bg-[#F0F3FF]'
            }
          >
            <img src={icon} className="" />
          </div>
        ) : null}

        {title && (
          <h2 className={clx('tw-text-lg tw-font-medium', styles.title)}>
            {title}
          </h2>
        )}
        {description && (
          <p className={clx('tw-font-regular tw-text-sm', styles.description)}>
            {description}
          </p>
        )}
      </div>
      <div className={styles.actionRow}>
        {handleClick && <FaIcon icon={faArrowRight} className={styles.btn} />}
      </div>
    </button>
  )
}
